// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mgb-sidebar {
  background-color: #023e8a;
  color: #ecf0f1;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 80px);
  position: relative;
  transition: width 0.3s ease;
}

.mgb-sidebar.collapsed {
  width: 80px;
}

.mgb-sidebar.expanded {
  width: 240px;
}

/* Toggle button with specific class names */
.mgb-sidebar-toggle-button {
  position: absolute;
  top: 10px;
  right: 1px;
  width: 24px;
  height: 24px;
  background-color: #4CAF50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  z-index: 10;
}

/* Organization header */
.mgb-sidebar-org-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Navigation menu */
.mgb-sidebar-nav-menu {
  flex: 1 1;
  padding: 1rem 0;
}

.mgb-sidebar-nav-menu ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.mgb-sidebar-nav-menu li {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  transition: all 0.3s;
}

.mgb-sidebar.collapsed .mgb-sidebar-nav-menu li {
  padding: 0.75rem 0;
  justify-content: center;
}

.mgb-sidebar-nav-menu li:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.mgb-sidebar-nav-menu li.active {
  background-color: rgba(255, 255, 255, 0.2);
  border-left: 4px solid #4CAF50;
}

.mgb-sidebar.collapsed .mgb-sidebar-nav-menu li.active {
  border-left: none;
  border-right: 4px solid #4CAF50;
}

/* Fix for oblong icons - ensure they are perfectly square */
.mgb-sidebar-nav-icon {
  width: 40px;
  height: 40px;
  background-color: rgba(41, 176, 255, 0.968);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  transition: transform 0.3s;
  min-width: 40px; /* Ensure minimum width */
  min-height: 40px; /* Ensure minimum height */
  max-width: 40px; /* Ensure maximum width */
  max-height: 40px; /* Ensure maximum height */
  box-sizing: border-box; /* Include padding in the width/height */
}

.mgb-sidebar.collapsed .mgb-sidebar-nav-icon {
  margin-right: 0;
}

.mgb-sidebar-nav-menu li:hover .mgb-sidebar-nav-icon {
  transform: scale(1.1);
}

.mgb-sidebar-nav-icon i {
  font-size: 1.2rem;
  color: #ecf0f1;
}

.mgb-sidebar-nav-menu li span {
  font-size: 0.9rem;
  color: #ecf0f1;
  white-space: nowrap;
}

/* Special icon styling with namespaced classes */
.mgb-sidebar-home-icon {
  background-color: #4CAF50;
}

.mgb-sidebar-dashboard-icon {
  background-color: #3498db;
}

/* User profile styling */
.mgb-sidebar-user-profile {
  padding: 1rem;
  display: flex;
  align-items: center;
  border-top: 1px solid rgb(105, 174, 220);
  margin-top: auto;
}

.mgb-sidebar.collapsed .mgb-sidebar-user-profile {
  justify-content: center;
  padding: 1rem 0;
}

.mgb-sidebar-avatar {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  min-width: 40px; /* Ensure minimum width */
  min-height: 40px; /* Ensure minimum height */
}

.mgb-sidebar.collapsed .mgb-sidebar-avatar {
  margin-right: 0;
}

.mgb-sidebar-avatar i {
  color: #000000;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .mgb-sidebar.expanded, 
  .mgb-sidebar.collapsed {
    width: 100%;
    height: auto;
    min-height: unset;
  }
  
  .mgb-sidebar-toggle-button {
    display: none; /* Hide the toggle button on mobile */
  }
  
  .mgb-sidebar-nav-menu ul {
    display: flex;
    justify-content: space-between;
  }
  
  .mgb-sidebar-nav-menu li {
    flex-direction: column;
    padding: 0.5rem;
    flex: 1 1;
    text-align: center;
  }
  
  .mgb-sidebar-nav-icon {
    margin-right: 0;
    margin-bottom: 0.25rem;
  }
}

@media print{
  .mgb-sidebar{
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/UserDashboard/navbar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe,EAAE,yBAAyB;EAC1C,gBAAgB,EAAE,0BAA0B;EAC5C,eAAe,EAAE,yBAAyB;EAC1C,gBAAgB,EAAE,0BAA0B;EAC5C,sBAAsB,EAAE,wCAAwC;AAClE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe,EAAE,yBAAyB;EAC1C,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa,EAAE,qCAAqC;EACtD;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".mgb-sidebar {\r\n  background-color: #023e8a;\r\n  color: #ecf0f1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: calc(100vh - 80px);\r\n  position: relative;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.mgb-sidebar.collapsed {\r\n  width: 80px;\r\n}\r\n\r\n.mgb-sidebar.expanded {\r\n  width: 240px;\r\n}\r\n\r\n/* Toggle button with specific class names */\r\n.mgb-sidebar-toggle-button {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 1px;\r\n  width: 24px;\r\n  height: 24px;\r\n  background-color: #4CAF50;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\r\n  z-index: 10;\r\n}\r\n\r\n/* Organization header */\r\n.mgb-sidebar-org-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 1.5rem 1rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Navigation menu */\r\n.mgb-sidebar-nav-menu {\r\n  flex: 1;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.mgb-sidebar-nav-menu ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.mgb-sidebar-nav-menu li {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.75rem 1.5rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.mgb-sidebar.collapsed .mgb-sidebar-nav-menu li {\r\n  padding: 0.75rem 0;\r\n  justify-content: center;\r\n}\r\n\r\n.mgb-sidebar-nav-menu li:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.mgb-sidebar-nav-menu li.active {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-left: 4px solid #4CAF50;\r\n}\r\n\r\n.mgb-sidebar.collapsed .mgb-sidebar-nav-menu li.active {\r\n  border-left: none;\r\n  border-right: 4px solid #4CAF50;\r\n}\r\n\r\n/* Fix for oblong icons - ensure they are perfectly square */\r\n.mgb-sidebar-nav-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  background-color: rgba(41, 176, 255, 0.968);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 0.75rem;\r\n  transition: transform 0.3s;\r\n  min-width: 40px; /* Ensure minimum width */\r\n  min-height: 40px; /* Ensure minimum height */\r\n  max-width: 40px; /* Ensure maximum width */\r\n  max-height: 40px; /* Ensure maximum height */\r\n  box-sizing: border-box; /* Include padding in the width/height */\r\n}\r\n\r\n.mgb-sidebar.collapsed .mgb-sidebar-nav-icon {\r\n  margin-right: 0;\r\n}\r\n\r\n.mgb-sidebar-nav-menu li:hover .mgb-sidebar-nav-icon {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.mgb-sidebar-nav-icon i {\r\n  font-size: 1.2rem;\r\n  color: #ecf0f1;\r\n}\r\n\r\n.mgb-sidebar-nav-menu li span {\r\n  font-size: 0.9rem;\r\n  color: #ecf0f1;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Special icon styling with namespaced classes */\r\n.mgb-sidebar-home-icon {\r\n  background-color: #4CAF50;\r\n}\r\n\r\n.mgb-sidebar-dashboard-icon {\r\n  background-color: #3498db;\r\n}\r\n\r\n/* User profile styling */\r\n.mgb-sidebar-user-profile {\r\n  padding: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  border-top: 1px solid rgb(105, 174, 220);\r\n  margin-top: auto;\r\n}\r\n\r\n.mgb-sidebar.collapsed .mgb-sidebar-user-profile {\r\n  justify-content: center;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.mgb-sidebar-avatar {\r\n  width: 40px;\r\n  height: 40px;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 0.75rem;\r\n  min-width: 40px; /* Ensure minimum width */\r\n  min-height: 40px; /* Ensure minimum height */\r\n}\r\n\r\n.mgb-sidebar.collapsed .mgb-sidebar-avatar {\r\n  margin-right: 0;\r\n}\r\n\r\n.mgb-sidebar-avatar i {\r\n  color: #000000;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .mgb-sidebar.expanded, \r\n  .mgb-sidebar.collapsed {\r\n    width: 100%;\r\n    height: auto;\r\n    min-height: unset;\r\n  }\r\n  \r\n  .mgb-sidebar-toggle-button {\r\n    display: none; /* Hide the toggle button on mobile */\r\n  }\r\n  \r\n  .mgb-sidebar-nav-menu ul {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .mgb-sidebar-nav-menu li {\r\n    flex-direction: column;\r\n    padding: 0.5rem;\r\n    flex: 1;\r\n    text-align: center;\r\n  }\r\n  \r\n  .mgb-sidebar-nav-icon {\r\n    margin-right: 0;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n}\r\n\r\n@media print{\r\n  .mgb-sidebar{\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
